import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { GenericError } from '../../GenericError/GenericError';
import type { LotteryName } from '../../lottery-purchases/types';

type LotteryErrorProps = {
  lotteryName: LotteryName;
  'data-testid'?: string;
};

function LotteryError({ lotteryName, 'data-testid': dataTestId = 'lottery-error' }: LotteryErrorProps) {
  const t = useTranslations('lotteries');

  return (
    <main className="ll-grid-container my-20" data-testid={dataTestId}>
      <GenericError
        title={t('error.title', { lotteryDisplayName: t(`${lotteryName}.name`) })}
        subtitle={t('error.subtitle')}
        cta={{ link: ROUTES.HOME, text: t('error.button_home') }}
        altText=""
      />
    </main>
  );
}

export { LotteryError, type LotteryErrorProps };
